var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoorlock = function SvgDoorlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 17,
    x: 15.5,
    y: 17.5,
    stroke: "currentColor",
    rx: 1.5,
    transform: "rotate(-180 15.5 17.5)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 5,
    y: 3.5,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-90 5 3.5)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 5,
    y: 5.5,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-90 5 5.5)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 8,
    y: 3.5,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-90 8 3.5)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 5,
    y: 7.5,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-90 5 7.5)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 8,
    y: 5.5,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-90 8 5.5)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 8,
    y: 7.5,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-90 8 7.5)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 11,
    y: 3.5,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-90 11 3.5)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 11,
    y: 5.5,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-90 11 5.5)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 2,
    x: 11,
    y: 7.5,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-90 11 7.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M9 9.5c1.087 0 2.01.695 2.355 1.667l.118.333h6.277a.75.75 0 0 1 0 1.5h-6.443l-.145.249A2.5 2.5 0 0 1 9 14.5a2.5 2.5 0 0 1 0-5Z"
  })));
};
export default SvgDoorlock;